function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.212891 1.25161C-0.0683594 0.97036 -0.0683594 0.502266 0.212891 0.211182C0.503974 -0.0700684 0.962235 -0.0700684 1.25332 0.211182L7.49654 6.4649L13.7503 0.211182C14.0315 -0.0700684 14.4996 -0.0700684 14.7802 0.211182C15.0713 0.502266 15.0713 0.971016 14.7802 1.25161L8.53697 7.49549L14.7802 13.7492C15.0713 14.0305 15.0713 14.4986 14.7802 14.7896C14.4989 15.0709 14.0309 15.0709 13.7503 14.7896L7.49654 8.53592L1.25332 14.7896C0.962235 15.0709 0.503974 15.0709 0.212891 14.7896C-0.0683594 14.4986 -0.0683594 14.0298 0.212891 13.7492L6.45612 7.49549L0.212891 1.25161Z",
  fill: "#A50A00"
});

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.6b17790d.svg";
export { ForwardRef as ReactComponent };